export const BRAND = {
  name: "MHJ Prestige Transport",
  short: "MHJ Prestige",
  phone: "07768 402139",
  phoneRaw: "+447768402139",
  whatsappRaw: "447768402139",
  email: "mhjprestigetransport@gmail.com",
  location: "Burton Upon Trent, UK",
  coverage: "UK & Europe — Nationwide",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/zyzryb9v_Screenshot_20260609_104548_Gallery.jpg",
  instagram: "mhjprestigetransport",
  instagramUrl: "https://www.instagram.com/mhjprestigetransport/",
};

export const SERVICES = [
  {
    id: "recovery",
    title: "Vehicle Recovery",
    tag: "24/7 Breakdown",
    blurb:
      "Rapid roadside recovery for cars, vans and prestige vehicles. Wherever you are — we come to you.",
    points: ["Roadside breakdown", "Jump start", "Vehicle transport home"],
  },
  {
    id: "transport",
    title: "Car Transport",
    tag: "Door-to-Door",
    blurb:
      "Open-trailer car transport for prestige, classic and high-value vehicles. Strapped down, secured, signed off.",
    points: ["Tilt & slide platform", "Soft straps & wheel nets", "Full handover photos"],
  },
  {
    id: "accident",
    title: "Accident Recovery",
    tag: "Insurance Approved",
    blurb:
      "Discreet accident recovery at any hour. We work with insurers and bodyshops to get your vehicle moved fast.",
    points: ["Direct to bodyshop", "Police & insurer liaison", "Damaged vehicle specialists"],
  },
  {
    id: "nationwide",
    title: "Nationwide Transport",
    tag: "UK Wide",
    blurb:
      "Long-distance vehicle movement across the UK. Auction collections, dealer trade and private buyer deliveries.",
    points: ["Auctions & dealerships", "Private collections", "Same-day options"],
  },
  {
    id: "european",
    title: "European Transport",
    tag: "Cross-Channel",
    blurb:
      "Vehicle movements into and out of Europe. Paperwork, ferries and continental drops handled end-to-end.",
    points: ["EU customs handling", "Ferry & Eurotunnel", "Multi-stop routing"],
  },
  {
    id: "storage",
    title: "Short-Term Storage",
    tag: "Secure · Indoor",
    blurb:
      "Secure short-term vehicle storage between collection and delivery. Indoor, monitored, insured — ideal for auction buys, holidays and dealer hold-overs.",
    points: ["CCTV monitored", "Indoor & dry", "Flexible duration"],
  },
];

export const TRUST_BADGES = [
  { label: "24/7 Recovery" },
  { label: "Fully Insured" },
  { label: "UK & Europe" },
  { label: "Prestige Specialists" },
];
